module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "restore-password"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-md-offset-3"
  }, [_c('div', {
    staticClass: "login"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("Restore Password")]), _vm._v(" "), (_vm.topMessage) ? _c('div', {
    staticClass: "alert alert-success"
  }, [_c('span', [_vm._v(_vm._s(_vm.topMessage))])]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    class: [_vm.email ? 'show-label' : '', 'form-group']
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.emailError) ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v(_vm._s(_vm.emailError))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b-button', {
    staticClass: "pull-left",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.restore($event)
      }
    }
  }, [_vm._v("Restore")])], 1)])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e222c128!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/profile/restore-password.vue
// module id = 566
// module chunks = 1